/**
 * Static content for /2026-workshop Learn and Resources tabs.
 */

import { WORKSHOP_FLYER_PATH } from '../constants/workshopFlyer';

export const WORKSHOP_2026_PDF_BASE = '/content/workshop-2026';

/** Printable 1-page invite with QR code → /2026-workshop */
export const WORKSHOP_INVITE_PDF = WORKSHOP_FLYER_PATH;

export interface PastWorkshop {
  year: string;
  summary: string;
}

/** Full history shown in the past-workshops FAQ. */
export const PAST_WORKSHOPS: PastWorkshop[] = [
  { year: '2025–2026', summary: 'Saturdays, Apr 2025 – May 2026 · 20 people · Online' },
  { year: '2024–2025', summary: 'Saturdays, Mar 2024 – Mar 2025 · 20 · Online' },
  { year: '2023', summary: 'Wednesdays, Jan 2023 – Oct 2023 · 15 · Online' },
  { year: '2022', summary: 'Saturdays, Jan 2022 – Oct 2022 · 20 · Online' },
  { year: '2021', summary: 'Saturdays, Feb 2021 – Oct 2021 · 20 · Online' },
  { year: '2019–2021', summary: 'Saturdays, Sep 2019 – Mar 2021 · 20 · San Jose, CA + Online' },
  { year: '2018–2019', summary: 'Thursdays, Jan 2018 – May 2019 · 20 · Indianapolis, IN' },
  { year: '2016–2017', summary: 'Tuesdays, Jan 2016 – Mar 2017 · 15 · Fishers, IN' },
  { year: '2013–2015', summary: 'Thursdays, Nov 2013 – Feb 2015 · 25 · Indianapolis, IN' },
  { year: '2011–2012', summary: 'Mondays, Jan 2011 – Jun 2012 · 20 · Brownsburg, IN' },
  { year: '2009–2010', summary: 'Thursdays, Jun 2009 – Aug 2010 · 30 · Indianapolis, IN' },
];

/** @deprecated Use PAST_WORKSHOPS */
export const PAST_WORKSHOPS_RECENT = PAST_WORKSHOPS.slice(0, 3);

/** @deprecated Use PAST_WORKSHOPS */
export const PAST_WORKSHOPS_FULL = PAST_WORKSHOPS;

export interface WorkshopResourceLink {
  label: string;
  href: string;
  description?: string;
  external?: boolean;
}

export const WORKSHOP_DOCUMENTS: WorkshopResourceLink[] = [
  {
    label: 'Introduction to the SAA Step Workshop',
    href: `${WORKSHOP_2026_PDF_BASE}/introduction-to-saa-step-workshop.pdf`,
    external: true,
  },
  {
    label: 'Invitation / overview',
    href: WORKSHOP_INVITE_PDF,
    description: 'One-page printable flyer with QR code to the workshop page.',
    external: true,
  },
];

export const RECOVERY_TOOLS: WorkshopResourceLink[] = [
  {
    label: 'Recovery Prayers',
    href: `${WORKSHOP_2026_PDF_BASE}/recovery-prayers.pdf`,
    external: true,
  },
  {
    label: '3 Circles Worksheet',
    href: '/saa/12-steps/getting-started',
    description: 'Personal 3 Circles tool on the Getting Started page.',
  },
];

export const SAA_MEETINGS_LINK: WorkshopResourceLink = {
  label: 'Find SAA meetings worldwide',
  href: 'https://www.saa-meetings.org',
  external: true,
};

export const FUTURE_LEADERS: WorkshopResourceLink[] = [
  {
    label: 'Starting and Running an SAA Step Workshop',
    href: `${WORKSHOP_2026_PDF_BASE}/starting-and-running-saa-workshop.pdf`,
    external: true,
  },
];
